export const LANDING_PAGE_EVENTS = {
  OFFERING_CARD_TAPPED:{
    LABEL:"lp_offerings_card_tapped",
    PROPERTIES:{
      current_url: "current_url",
      screen_width: "screen_width",
      utm_params: "utm_params",
      card_title:"card_title"
    }
  },
  NAV_ITEM_EXPANDED: {
    LABEL: "lp_nav_item_expanded",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      item_name: "item_name",
    },
  },
  NAV_ITEM_TAPPED: {
    LABEL: "lp_nav_item_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      item_name: "item_name",
    },
  },
  SIGN_IN_TAPPED: {
    LABEL: "lp_sign_in_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      source: "source",
      utm_params: "utm_params",
      index: "index",
      signup_version: "signup_version"
    },
  },
  SIGN_UP_TAPPED: {
    LABEL: "lp_signup_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      source: "source",
      index: "index",
      utm_params: "utm_params",
    },
  },
  BOOK_DEMO_TAPPED: {
    LABEL: "lp_book_demo_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      source: "source",
    },
  },
  LEARN_MORE_TAPPED: {
    LABEL: "lp_learn_more_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      source: "source",
      index: "index",
    },
  },
  EXPLORE_CREATORS_TAPPED: {
    LABEL: "lp_explore_creators_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      source: "source",
    },
  },
  FEATURE_CARD_TAPPED: {
    LABEL: "lp_feature_card_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      index: "index",
      feature_name: "feature_name",
    },
  },
  FOOTER_ITEM_TAPPED: {
    LABEL: "lp_footer_item_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      section_name: "section_name",
      item_name: "item_name",
      utm_params: "utm_params",
    },
  },
  FAQ_EXPANDED: {
    LABEL: "lp_faq_expanded",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      faq_title: "faq_title",
    },
  },
  PRODUCT_DETAIL_EXPANDED: {
    LABEL: "lp_product_detail_expanded",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      feature: "feature",
    },
  },
  PRODUCT_FEATURE_DETAIL_EXPANDED: {
    LABEL: "lp_product_feature_detail_expanded",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      product: "product",
      product_feature_title: "product_feature_title",
    },
  },
  SUBFEATURE_DETAIL_EXPANDED: {
    LABEL: "lp_subfeature_detail_expanded",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      feature: "feature",
      subfeature_title: "subfeature_title",
    },
  },
  SLIDER_NEW_VALUE_SELECTED: {
    LABEL: "lp_slider_new_value_selected",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      metric: "metric",
      value: "value",
    },
  },
  VISIT_HELP_CENTER_TAPPED: {
    LABEL: "lp_visit_help_centre_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      source: "source",
    },
  },
  CREATOR_WEBSITE_TAPPED: {
    LABEL: "lp_creator_website_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      creator_name: "creator_name",
      creator_domain: "creator_domain",
      creator_category: "creator_category",
      index: "index",
    },
  },
  CREATOR_CATERGORY_SELECTED: {
    LABEL: "lp_creator_category_selected",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      category: "category",
    },
  },
  ALL_CREATOR_CATEGORIES_TAPPED: {
    LABEL: "lp_all_creator_categories_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
    },
  },
  HAMBURGER_TAPPED: {
    LABEL: "lp_hamburger_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
    },
  },
};

export const AUTH_EVENTS = {
  LOGIN_MODAL_EMAIl_ENTERED: {
    LABEL: "login_modal_email_entered",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      email: "email",
    },
  },
  LOGIN_MODAL_LOGIN_TAPPED: {
    LABEL: "signup_otp_requested",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      method: "method",
      signup_type: "signup_type",
      signup_version: "signup_version",
    },
  },
  LOGIN_MODAL_DISMISSED: {
    LABEL: "login_modal_dismissed",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
    },
  },
  LOGIN_MODAL_RESEND_OTP_TAPPED: {
    LABEL: "login_modal_resend_otp_tapped",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
    },
  },
  LOGIN_MODAL_INVALID_OTP_ERROR: {
    LABEL: "login_modal_invalid_otp_error",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
    },
  },
  CREATOR_LOGIN_SUCCESS: {
    LABEL: "creator_login_success",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      login_method: "login_method",
      email: "email",
    },
  },
  CREATOR_LOGIN_FAILED: {
    LABEL: "creator_login_failed",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      login_method: "login_method",
      email: "email",
      reason: "reason",
    },
  },
  SIGNUP_EMAIl_ENTERED: {
    LABEL: "signup_email_entered",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      email: "email",
      signup_type: "signup_type",
      signup_version: "signup_version",
    },
  },
  SIGNUP_MODAL_DISMISSED: {
    LABEL: "signup_modal_dismissed",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
    },
  },
  SIGNUP_NAME_ENTERED: {
    LABEL: "signup_name_entered",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      name: "name",
      signup_type: "signup_type",
      email: "email",
      signup_version: "signup_version",
    },
  },
  SIGNUP_PHONE_NUMBER_ENTERED: {
    LABEL: "signup_phone_number_entered",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      phone_number: "phone_number",
      signup_type: "signup_type",
      signup_version: "signup_version",
    },
  },
  SIGNUP_PHONE_COUNTRY_SELECTED: {
    LABEL: "signup_phone_country_selected",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      phone_country: "phone_country",
      signup_type: "signup_type",
    },
  },
  CREATOR_SIGNUP_SUCCESS: {
    LABEL: "creator_signup_success",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      name: "name",
      email: "email",
      phone_number: "phone_number",
      phone_country: "phone_country",
      signup_type: "signup_type",
      signup_version: "signup_version",
    },
  },
  CRETOR_SIGNUP_SUCCESS_SERVER: {
    LABEL: "creator_signup_success_server",
    PROPERTIES: {
      utm_params: "utm_params",
      name: "name",
      email: "email",
      phone_number: "phone_number",
      phone_country: "phone_country",
      signup_type: "signup_type",
      referrer: "referrer",
    },
  },
  CREATOR_ACCOUNT_CREATION: {
    LABEL: "creator_account_creation",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      name: "name",
      email: "email",
      phone: "phone",
    },
  },
  SIGNIN_GOOGLE_CLICKED: {
    LABEL: 'signin_google_clicked',
    PROPERTIES: {
      current_url: "current_url",
      utm_params: "utm_params",
      signup_version: "signup_version",
      screen_width: "screen_width",
      referrer: "referrer",
      method: "method",
      signup_type: "signin"
    }
  },
  SIGNUP_GOOGLE_CLICKED: {
    LABEL: 'signup_google_clicked',
    PROPERTIES: {
      current_url: "current_url",
      utm_params: "utm_params",
      signup_version: "signup_version",
      screen_width: "screen_width",
      referrer: "referrer",
      method: "method",
      signup_type : "signup"
    }
  },
  SIGNUP_GET_STARTED_CLICKED: {
    LABEL: "signup_get_started_clicked",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      signup_type: "signup_type",
      signup_version: "signup_version",
      otp_type: "otp_type",
    },
  },                       
  SIGNUP_PAGE_VIEWED: {
    LABEL: "signup_page_viewed",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      variation: "variation",
      visitor_id: "visitor_id",
    },
  },
  SIGNIN_PAGE_VIEWED: {
    LABEL: "signin_page_viewed",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      variation: "variation",
      visitor_id: "visitor_id",
    },
  },
  SIGNUP_OTP_SUBMITTED: {
    LABEL: "signup_otp_submitted",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      source: "source",
      type: "type",
      version: "version",
      login_method: "login_method",
      visitor_id: "visitor_id",
    },
  },
  SIGNIN_OTP_SUBMITTED: {
    LABEL: "signin_otp_submitted",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      source: "source",
      type: "type",
      version: "version",
      login_method: "login_method",
      visitor_id: "visitor_id",
    },
  },
  SIGNIN_OTP_REQUESTED: {
    LABEL: "signin_otp_requested",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      method: "method",
      signup_type: "signup_type",
      signup_version: "signup_version",
    },
  },
  SIGNUP_STATUS: {
    LABEL: 'Signup_Status',
    PROPERTIES: {
      current_url: "current_url",
      utm_params: "utm_params",
      screen_width: "screen_width",
      referrer: "referrer",
      status: "status",
      user_id: "user_id",
      reason: "reason",
      user_type: "user_type",
      visitor_id:"visitor_id",
      method : "method",
    }
  }
};


export const MARKETING_PAGE_EVENTS = {
  REQUEST_A_DEMO_FORM_FILLED: {
    LABEL: "marketing_request_a_demo_form_filled",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      referrer: "referrer",
      utm_params: "utm_params",
      email: "email",
      phone_number:"phone_number",
      phone_country:"phone_country",
      source:"source",
      name:"name"
    },
  },
  ADDITIONAL_DETAILS_SAVED: {
    LABEL: "marketing_demo_additional_details_saved",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      utm_params: "utm_params",
      currently_selling: "currently_selling",
      category:"category",
      social_media_size:"social_media_size",
      existing_website:"existing_website",
    },
  },
  ADDITIONAL_DETAILS_MODAL_DISMISSED: {
    LABEL: "additional_details_modal_dismissed",
    PROPERTIES: {
      current_url: "current_url",
      screen_width: "screen_width",
      utm_params: "utm_params"
    },
  },
}


export const EXIT_INTENT_EVENTS = {
  POPUP_SHOWN: {
    LABEL: "popup_shown",
    PROPERTIES: {
      current_url: "current_url",
      variant: "variant",
      delay: "delay",
      timestamp: "timestamp"
    }
  },
  POPUP_NAME_ENTERED: {
    LABEL: "popup_name_entered",
    PROPERTIES: {
      current_url: "current_url",
      utm_params: "utm_params",
      variant: "variant"
    }
  },
  POPUP_EMAIL_ENTERED: {
    LABEL: "popup_email_entered",
    PROPERTIES: {
      current_url: "current_url",
      utm_params: "utm_params",
      variant: "variant"
    }
  },
  POPUP_PHONE_ENTERED: {
    LABEL: "popup_phone_entered",
    PROPERTIES: {
      current_url: "current_url",
      utm_params: "utm_params",
      variant: "variant"
    }
  },
  POPUP_JOIN_NOW: {
    LABEL: "popup_join_now",
    PROPERTIES: {
      current_url: "current_url",
      utm_params: "utm_params",
      variant: "variant",
      name: "name",
      email: "email",
      phone: "phone"
    }
  },
  POPUP_DISMISSED: {
    LABEL: "popup_dismissed",
    PROPERTIES: {
      current_url: "current_url",
      utm_params: "utm_params",
      variant: "variant",
      email: "email"
    }
  }
};

